module.exports = __webpack_public_path__ + "static/media/send-post-flyer.0a8e9cb2.svg";